import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import CardView from "../../../../components/common/CardView";
import FileUpload from "../../../../components/common/FileUpload";
import InputRow from "../../my-component/InputRow";
import PerformanceTable from "../../my-component/PerformanceTable";
import { DatePicker, Space } from "antd";
import InputFactory from "../../../../components/InputFactory";
import SPCRFormPresenter from "./SPCRFormPresenter";
import dayjs from "dayjs";
import { findCurrentUserEmployee, buildHierarchyWhere } from "../../../../utils/hierarchy";

class SPCRForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      periodFrom: "",
      periodTo: "",
      addRow: false,
      sectionoutcome: "",
      successindicators: "",
      allottedbudget: "",
      // individualsaccountable: "",
      actualaccomplishments: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      ipcrForm: [],
      isRating: false,
      object: {},
      indexToEdit: null,
      searchTerm: "",
      rating: ["Quality", "Efficiency", "Timeliness"],
      inputField: [
        "Section Outcome",
        "Success Indicators",
        "Allotted Budget",
        // "Individuals Accountable",
        "Actual Accomplishments",
      ],
      assignedEmployee: {},
      findEmp: [],
      where: {},
      whereReady: false,
    };
    this.presenter = new SPCRFormPresenter(
      this,
      findObjectUseCase(),
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  handleRatingClick() {
    this.setState((prevState) => ({ isRating: !prevState.isRating }));
  }

  getCollectionName() {
    return "spcr";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const params = this.getParams().id || "";

    const query = {
      where: {
        id: params,
      },
      include: ["all"],
    };

    const [employees, findEmp] = await Promise.all([
      findCurrentUserEmployee(findObjectUseCase(), this.getCurrentUser()),
      findObjectUseCase().execute("spcr", query),
    ]);

    const where = buildHierarchyWhere(employees?.[0]);

    this.setState({ findEmp, where, whereReady: true });
  }

  componentDidUpdate(prevProps, prevState) {
    const { object, indexToEdit, ipcrForm } = this.state;
    if (prevState.object !== object && indexToEdit !== null) {
      const getObject = ipcrForm[indexToEdit];
      if (getObject) {
        this.setState({
          // sectionoutcome: getObject.sectionoutcome,
          // successindicators: getObject.successindicators,
          // allottedbudget: getObject.allottedbudget,
          // actualaccomplishments: getObject.actualaccomplishments,
          // quality: getObject.quality,
          // efficiency: getObject.efficiency,
          // timeliness: getObject.timeliness,
          // remarks: getObject.remarks,
          ...getObject,
        });
      }
    }

    if (prevState.object !== this.state.object) {
      if (this.state.object.length > 0) {
        const object = this?.state?.object?.find(
          (item) => item.id === this.getObjectId()
        );
        this.setState({
          ipcrForm: object.performance,
          selectedFiles: object.selectedFiles,
          modifyFiles: object.modifyFiles,
          periodFrom: object.periodFrom,
          periodTo: object.periodTo,
          assignedEmployee: object.assignedEmployee,
        });
      }
    }
  }

  handleAddRow() {
    this.setState({
      sectionoutcome: "",
      successindicators: "",
      allottedbudget: "",
      actualaccomplishments: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      addRow: true,
      indexToEdit: null,
      object: {},
      selectedFiles: [],
      modifyFiles: [],
    });
  }

  handleCloseRow() {
    this.setState({ addRow: false });
  }

  handleChange(field, value) {
    this.setState({ [field]: value });
  }

  handleRatingChange(field, value) {
    const regex = /^(\d{0,1}(\.\d{0,2})?)?$/;
    if (!regex.test(value)) {
      value = "";
    } else if (parseFloat(value) > 5) {
      value = "5";
    }
    this.setState({ [field]: value });
  }

  handleRemarksChange(remarks) {
    this.setState({ remarks });
  }

  handleAddData() {
    const primaryObject = this.state;

    const scores = [
      parseFloat(primaryObject.quality),
      parseFloat(primaryObject.efficiency),
      parseFloat(primaryObject.timeliness),
    ];

    const validScores = scores.filter((score) => !isNaN(score));
    const sum = validScores.reduce((sum, item) => sum + item, 0);
    const average = validScores.length > 0 ? sum / validScores.length : 0;

    const data = {
      sectionoutcome: primaryObject.sectionoutcome,
      successindicators: primaryObject.successindicators,
      allottedbudget: primaryObject.allottedbudget,
      actualaccomplishments: primaryObject.actualaccomplishments,
      quality: primaryObject.quality,
      efficiency: primaryObject.efficiency,
      timeliness: primaryObject.timeliness,
      average,
      remarks: primaryObject.remarks,
    };

    if (primaryObject.indexToEdit !== null) {
      const updatedForm = primaryObject.ipcrForm.map((item, index) =>
        index === primaryObject.indexToEdit ? data : item
      );
      this.setState({
        ipcrForm: updatedForm,
        addRow: false,
        indexToEdit: null,
      });
    } else {
      this.setState((prevState) => ({
        ipcrForm: [...prevState.ipcrForm, data],
        addRow: false,
      }));
    }
  }

  handleTrashData(indexToRemove) {
    const removedItem = this.state.ipcrForm.filter(
      (_, index) => index !== indexToRemove
    );
    this.setState({ ipcrForm: removedItem });
  }

  handleEditData(object, indexToEdit) {
    this.setState({
      object,
      indexToEdit,
      addRow: true,
      sectionoutcome: object.sectionutcome,
      successindicators: object.successindicators,
      allottedbudget: object.allottedbudget,
      actualaccomplishments: object.actualaccomplishments,
      quality: object.quality,
      efficiency: object.efficiency,
      timeliness: object.timeliness,
      remarks: object.remarks,
    });
  }

  handleSearch(event) {
    this.setState({ searchTerm: event.target.value });
  }

  // changeFile
  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  handleFileChange2(modifyFiles) {
    this.setState({ modifyFiles });
  }

  onChange(value, field) {
    console.log({ [field]: value });
    this.setState({ [field]: value });
    // this.presenter.onChange(value, field);
  }

  render() {
    const primaryObject = this.state;
    const isMobile = window.innerWidth <= 768;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    const params = this.getParams().id;
    console.log("pp", this.state.findEmp[0]?.assignedEmployee);
    const update = primaryObject;

    console.log("update", update);
    const objectArray = Array.isArray(update.object)
      ? update.object
      : [update.object];
    const filteredObject = objectArray.filter((item) => item.id === params);
    console.log("Filtered Object:", filteredObject);

    if (!schema) return <h1>No schema</h1>;

    const filteredIpcrForm = primaryObject.ipcrForm.filter((item) =>
      Object.values(item).some((val) =>
        val
          ?.toString()
          .toLowerCase()
          .includes(primaryObject.searchTerm.toLowerCase())
      )
    );

    console.log("filtered results", filteredIpcrForm);

    const fields = [
      ...primaryObject.inputField,
      ...primaryObject.rating,
      "average",
      "remarks",
    ].map((field) => field.replace(" ", "").toLowerCase());

    // console.warn("FIELD:", fields);
    const { RangePicker } = DatePicker;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className={`h-100 ${isMobile ? "p-1" : "p-2 m-4"}`}>
            <CardView style={{ borderRadius: 0, padding: 0 }}>
              <div>
                <h6 className="ps-4 pt-4">
                  <b>SECTION PERFORMANCE COMMITMENT AND REVIEW (SPCR)</b>
                </h6>
                <hr />
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.handleFormSubmit();
                }}
                className="p-3"
              >
                <div>
                  <label>
                    Period <span className="text-danger">*</span>
                  </label>
                  <br />
                  <Space direction="vertical" size={20}>
                    <RangePicker
                      required
                      value={
                        this.state.periodFrom && this.state.periodTo
                          ? [
                              dayjs(this.state.periodFrom),
                              dayjs(this.state.periodTo),
                            ]
                          : null
                      }
                      onChange={(date, value) =>
                        this.setState({
                          periodFrom: value[0],
                          periodTo: value[1],
                        })
                      }
                      className="custom-range-picker border p-2 fw-semibold"
                    />
                  </Space>
                  {this.state.whereReady ? (
                  <div className="mt-2">
                    <label>
                      Employee <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      className="col-6"
                      type="Pointer"
                      key={JSON.stringify(this.state.where)}
                      where={this.state.where}
                      // defaultValue={filteredObject[0]?.assignedEmployee}
                      defaultValue={this.state.findEmp[0]?.assignedEmployee}
                      field="assignedEmployee"
                      target="employees"
                      onChange={this.onChange.bind(this)}
                      placeholder="Select Employee"
                    />
                  </div>
                  ) : (
                    <div className="text-muted fs-sm py-2">
                      Loading employee list...
                    </div>
                  )}

                  <div className="border mt-4 p-0">
                    <div className="row pt-2 ps-2 pe-2 pb-0 m-0">
                      <div className="d-grid col-lg-6">
                        {[5, 4, 3, 2, 1].map((score, index) => (
                          <span key={index}>
                            {score} -{" "}
                            {
                              [
                                "Outstanding",
                                "Very Satisfactory",
                                "Satisfactory",
                                "Unsatisfactory",
                                "Poor",
                              ][index]
                            }
                          </span>
                        ))}
                      </div>
                      <div className="col-lg-6 d-flex align-items-end gap-3">
                        <input
                          type="search"
                          className="form-control rounded ps-5"
                          placeholder="Search"
                          onChange={this.handleSearch.bind(this)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary w-25"
                          onClick={this.handleAddRow.bind(this)}
                        >
                          <i className="bi bi-plus-lg" /> {schema.collection}
                        </button>
                      </div>
                      <div className="pt-1 ps-1 pe-1 pb-0">
                        <PerformanceTable
                          tableHeader={[
                            "#",
                            "Section Outcome",
                            "(Targets + Measures)",
                            "Allotted Budget",
                            // "Individuals Accountable",
                            "Actual Accomplishments",
                            "Q1",
                            "E2",
                            "T3",
                            "A4",
                            "Remarks",
                            "Actions",
                          ]}
                          // formulaHeader={[
                          //   "",
                          //   "",
                          //   "",
                          //   "",
                          //   "",
                          //   "(h)",
                          //   "(i)",
                          //   "(j)",
                          //   "(k = ave of h, i, j)",
                          //   "(m)",
                          //   "",
                          // ]}
                          tableBody={fields}
                          object={filteredIpcrForm}
                          handleRatingClick={this.handleRatingClick.bind(this)}
                          isRating={this.state.isRating}
                          handleTrashData={this.handleTrashData.bind(this)}
                          handleEditData={this.handleEditData.bind(this)}
                        />
                      </div>

                      {/* final Rating  */}
                      <div className="border row m-auto mb-2">
                        {filteredIpcrForm && (
                          <>
                            <div className="col-lg-6 fs-6">
                              <div>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={7}
                                >
                                  <b>TOTAL RATING</b>
                                </label>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={3}
                                >
                                  {filteredIpcrForm
                                    .reduce(
                                      (sum, item) =>
                                        sum + parseFloat(item.average),
                                      0
                                    )
                                    .toFixed(2)}
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={7}
                                >
                                  <b>FINAL AVERAGE RATING</b>
                                </label>
                                <label
                                  style={{
                                    padding: "5px",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                  }}
                                  colSpan={3}
                                >
                                  {filteredIpcrForm
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(item.average) /
                                          filteredIpcrForm.length,
                                      0
                                    )
                                    .toFixed(2)}
                                </label>
                              </div>
                            </div>
                            <div className="col-lg-6 fs-6">
                              <div
                                className="d-flex align-items-center border"
                                style={{
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <label className="ps-2">
                                  Name and Signature of Rater:
                                </label>
                                <InputFactory
                                  type="String"
                                  field="headName"
                                  defaultValue={this.state.findEmp[0]?.headName}
                                  onChange={this.onChange.bind(this)}
                                  className="border-0"
                                  required
                                />
                              </div>
                              <div
                                className="d-flex align-items-center border"
                                style={{
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <label className="ps-2">Position: </label>
                                <InputFactory
                                  type="String"
                                  field="headPosition"
                                  defaultValue={
                                    this.state.findEmp[0]?.headPosition
                                  }
                                  onChange={this.onChange.bind(this)}
                                  className="border-0"
                                  required
                                />
                              </div>
                            </div>
                            {/* second */}
                            <div className="col-lg-6 fs-6">
                              <div
                                className="d-flex align-items-center border"
                                style={{
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <label className="ps-2">
                                  Name and Signature of Rater:
                                </label>
                                <InputFactory
                                  type="String"
                                  field="finalName"
                                  defaultValue={
                                    this.state.findEmp[0]?.finalName
                                  }
                                  onChange={this.onChange.bind(this)}
                                  className="border-0"
                                  required
                                />
                              </div>
                              <div
                                className="d-flex align-items-center border"
                                style={{
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <label className="ps-2">Position: </label>
                                <InputFactory
                                  type="String"
                                  field="finalPosition"
                                  defaultValue={
                                    this.state.findEmp[0]?.finalPosition
                                  }
                                  onChange={this.onChange.bind(this)}
                                  className="border-0"
                                  required
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center p-3">
                    <div
                      className="col-lg-1 border"
                      style={{ height: "1px" }}
                    />
                    <span className="col-lg-2 text-center">
                      <i className="bi bi-file-earmark" /> Attachments
                    </span>
                    <div
                      className="col-lg-9 border"
                      style={{ height: "1px" }}
                    />

                    <div className="col-lg-12 mt-5">
                      <InputFactory
                        type="File"
                        onChange={this.handleFileChange.bind(this)}
                        value={this.state.selectedFiles}
                        className="form-control"
                      />
                    </div>
                    {filteredObject[0]?.stats === "Pending" && (
                      <div className="col-lg-12 mt-5">
                        <InputFactory
                          type="File"
                          onChange={this.handleFileChange2.bind(this)}
                          value={this.state.modifyFiles}
                          className="form-control"
                        />
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div className="mb-4 ms-auto pe-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm me-3"
                    onClick={this.onClickBack.bind(this)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary fs-sm">
                    <i className="bi bi-file-earmark-check me-2"></i>
                    {label}
                  </button>
                </div>
              </form>
            </CardView>
          </div>
        </div>

        {primaryObject.addRow && (
          <InputRow
            ratings={primaryObject.rating}
            inputField={primaryObject.inputField}
            handleRatingClick={this.handleRatingClick.bind(this)}
            handleAddData={this.handleAddData.bind(this)}
            handleCloseRow={this.handleCloseRow.bind(this)}
            handleRemarksChange={this.handleRemarksChange.bind(this)}
            handleChange={this.handleChange.bind(this)}
            handleRatingChange={this.handleRatingChange.bind(this)}
            primaryObject={primaryObject}
          />
        )}
      </>
    );
  }
}

export default withRouter(SPCRForm);
